module.exports = __webpack_public_path__ + "static/img/243_TO8_2186_og.bbeeca7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/243_TO8_2186_og.jpg
// module id = qVa8
// module chunks = 0